// frontend/src/pages/admin/UserManagementPage.jsx (نسخه آپدیت شده)

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL, getAuthHeaders } from '../../modules/api';
import { FaPlus, FaSearch, FaSpinner, FaEdit, FaTrash } from 'react-icons/fa';
import UserFormModal from './UserFormModal'; // ✅ ایمپورت کامپوننت مودال

const UserManagementPage = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    
    // ✅ State برای کنترل باز و بسته بودن مودال
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/auth/users/`, getAuthHeaders());
                setUsers(response.data);
            } catch (err) {
                setError("خطا در دریافت لیست کاربران.");
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
    }, []);

    // ✅ تابعی که بعد از ایجاد موفق کاربر، آن را به لیست اضافه می‌کند
    const handleUserAdded = (newUser) => {
        setUsers(prevUsers => [newUser, ...prevUsers]); // کاربر جدید را در ابتدای لیست قرار می‌دهد
    };

    // ... (بقیه توابع مثل filteredUsers و getRoleNameInFarsi بدون تغییر باقی می‌مانند)
    const filteredUsers = users.filter(user => 
        user.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
        `${user.first_name} ${user.last_name}`.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const getRoleNameInFarsi = (role) => {
        const roles = {
            NationalAdmin: 'مدیر کل کشور', ProvinceAdmin: 'مدیر استان',
            CityAdmin: 'مدیر شهرستان', SchoolAdmin: 'مدیر مدرسه',
            Teacher: 'معلم', Student: 'دانش‌آموز',
        };
        return roles[role] || role;
    };


    if (loading) return <div className="text-center p-5"><FaSpinner className="spinner" /> در حال بارگذاری...</div>;
    if (error) return <div className="alert alert-danger">{error}</div>;

    return (
        <> {/* ✅ استفاده از Fragment برای قرار دادن مودال در کنار صفحه */}
            <UserFormModal 
                isOpen={isModalOpen} 
                onClose={() => setIsModalOpen(false)} 
                onUserAdded={handleUserAdded} 
            />

            <div className="page-container" style={{maxWidth: '1200px'}}>
                <div className="page-header">
                    <div>
                        <h1>مدیریت کاربران</h1>
                        <p>لیست کاربران سامانه بر اساس سطح دسترسی شما.</p>
                    </div>
                    {/* ✅ دکمه اکنون مودال را باز می‌کند */}
                    <button className="button button-primary" onClick={() => setIsModalOpen(true)}>
                        <FaPlus /> افزودن کاربر جدید
                    </button>
                </div>

                {/* بقیه JSX بدون تغییر ... */}
                <div className="data-table-container">
                    <div className="table-toolbar">
                        <div className="search-box">
                            <FaSearch className="search-icon" />
                            <input
                                type="text"
                                placeholder="جستجوی نام یا نام کاربری..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>

                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>نام کامل</th>
                                <th>نام کاربری (کد ملی)</th>
                                <th>نقش</th>
                                <th>سازمان</th>
                                <th>وضعیت</th>
                                <th>عملیات</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredUsers.length > 0 ? filteredUsers.map(user => (
                                <tr key={user.id}>
                                    <td>{user.first_name} {user.last_name}</td>
                                    <td>{user.username}</td>
                                    <td>{getRoleNameInFarsi(user.role)}</td>
                                    <td>{user.organization_name || '—'}</td>
                                    <td>
                                        <span className={`status-badge ${user.is_active ? 'status-active' : 'status-inactive'}`}>
                                            {user.is_active ? 'فعال' : 'غیرفعال'}
                                        </span>
                                    </td>
                                    <td>
                                        <div className="action-buttons">
                                            <button className="action-btn btn-edit" title="ویرایش"><FaEdit /></button>
                                            <button className="action-btn btn-delete" title="حذف"><FaTrash /></button>
                                        </div>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="6" className="text-center">هیچ کاربری یافت نشد.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default UserManagementPage;